import ExportVM from './export-vm';
export default {
  init: function(node){
    console.log('Initializing Kadenze.CourseExport');

    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    validationOptions.grouping = { deep: true, observable: true, live: true };
    let data = node.dataset.exportData;
    ko.applyBindingsWithValidation(new ExportVM(data), node, validationOptions);
  }
};

